@if (is_loading) {
  <mat-progress-bar color="accent" mode="indeterminate"></mat-progress-bar>
}



<div style="margin: 0px;">
  @if (myForm) {
    <form [formGroup]="myForm" (ngSubmit)="onSubmit()" novalidate>


      <!--    <ng-container *ngIf="!is_loading">-->

      <div [hidden]="is_loading">

        <mat-card  style="width: 400px; margin-top: 20px; margin-left: 20px;">

          <mat-card-header>
            <h2>Campaign Group Sequence</h2>
          </mat-card-header>

          <mat-card-content>


            <mat-form-field style="margin-top: 15px; width: 100%">
              <mat-label>Campaign Group Sequence Name:</mat-label>
              <input matInput type="text" placeholder="e.g. foo" (focus)="onFocus()" formControlName="name">
              <mat-error style="font-size: 12px">Valid name required</mat-error>
            </mat-form-field>

            <mat-form-field style="margin-top: 15px; width: 100%">
              <mat-label>Alias:</mat-label>
              <input matInput type="text" placeholder="e.g. foo" (focus)="onFocus()" formControlName="alias">
              <mat-error style="font-size: 12px">Valid alias required</mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill" style="margin-top: 15px; width: 100%">
              <mat-label>Campaign Staleness Threshold (days)</mat-label>
              <span matTooltip="Select the staleness threshold in days">
              <mat-select formControlName="campaign_staleness_threshold_in_days">
                @for (day of daysOptions; track day) {
                  <mat-option [value]="day">{{ day }}</mat-option>
                }
              </mat-select>
            </span>
            </mat-form-field>


            <mat-form-field appearance="fill"  style="margin-top: 15px; width: 100%">
              <mat-label>Recurrent Cooldown (days)</mat-label>
              <mat-select formControlName="recurrent_cooldown_in_days">
                @for (day of daysOptions; track day) {
                  <mat-option [value]="day">{{ day }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill"  style="margin-top: 15px; width: 100%">
              <mat-label>Max Recurrent Count</mat-label>
              <mat-select formControlName="max_recurrence_count">
                @for (day of maxRecurrence; track day) {
                  <mat-option [value]="day">{{ day }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field style="margin-top: 15px; width: 100%">
              <mat-label>Control Group Rate</mat-label>
              <mat-select formControlName="control_rate" >
                @for (option of controlRateOptions; track option.value) {
                  <mat-option [value]="option.value">
                    {{ option.viewValue }}
                  </mat-option>
                }
              </mat-select>
              <mat-error style="font-size: 12px">Please select a valid Control Rate</mat-error>
            </mat-form-field>


            <div style="margin-top: 15px; width: 100%">
              <mat-slide-toggle formControlName="status" (change)="onFocus()">
                {{ myForm.get('status')?.value === true ? 'Active' : 'Paused' }}
              </mat-slide-toggle>
            </div>

<!--            <div style="margin-top: 15px; width: 100%">-->
<!--              <mat-slide-toggle formControlName="is_recurrent" (change)="onFocus()">-->
<!--                {{ myForm.get('is_recurrent')?.value === true ? 'Recurrent' : 'Not Recurrent' }}-->
<!--              </mat-slide-toggle>-->
<!--            </div>-->

<!--            <div style="margin-top: 15px; width: 100%">-->
<!--              <mat-slide-toggle formControlName="is_pre_scheduled" (change)="onFocus()">-->
<!--                {{ myForm.get('is_pre_scheduled')?.value === true ? 'Pre-Scheduled' : 'Not Pre-Scheduled' }}-->
<!--              </mat-slide-toggle>-->
<!--            </div>-->



            <mat-list>
              <mat-list-item></mat-list-item>
              <mat-divider></mat-divider>
              <mat-list-item>
                <mat-checkbox formControlName="adjust_weekend_stale" (change)="onFocus()">
                  Weekend Adjust for Stale
                </mat-checkbox>
              </mat-list-item>
              <mat-list-item>
                <mat-checkbox formControlName="is_recurrent" (change)="onFocus()">
                  Recurrent
                </mat-checkbox>
              </mat-list-item>
              <mat-list-item>
                <mat-checkbox formControlName="is_pre_scheduled" (change)="onFocus()">
                  Pre-Scheduled
                </mat-checkbox>
              </mat-list-item>
              <mat-list-item>
                <mat-checkbox formControlName="terminate_if_blown" (change)="onFocus()">
                  Terminate if Blown
                </mat-checkbox>
              </mat-list-item>
              <mat-list-item>
                <mat-checkbox formControlName="self_service_sms" (change)="onFocus()">
                  Self Service SMS
                </mat-checkbox>
              </mat-list-item>
            </mat-list>


<!--            <mat-list>-->
<!--              <mat-list-item>Self Service</mat-list-item>-->
<!--              <mat-divider></mat-divider>-->
<!--              <mat-list-item>-->
<!--                <mat-checkbox formControlName="self_service_sms" (change)="onFocus()">-->
<!--                  SMS-->
<!--                </mat-checkbox>-->
<!--              </mat-list-item>-->
<!--            </mat-list>-->

          </mat-card-content>





<!--          <mat-form-field style="margin-top: 15px; width: 100%">-->
<!--            <mat-label>Parent Campaign Group Sequence</mat-label>-->
<!--            <mat-select formControlName="campaign_group_sequence_parent_id" >-->
<!--              @for (group of campaign_group_sequence_select_list; track group.id) {-->
<!--                <mat-option [value]="group.id">-->
<!--                  {{ group.name }}-->
<!--                </mat-option>-->
<!--              }-->
<!--            </mat-select>-->
<!--            <mat-error style="font-size: 12px">Please select a valid campaign group sequence</mat-error>-->
<!--          </mat-form-field>-->

          <mat-card-actions>
            <div class="flex-container" style="margin-top: 10px;">
              <button mat-raised-button color="primary" [disabled]="!myForm.valid || is_loading" type="submit" style="margin: 15px">{{ submit_text }}
              </button>
              <button mat-raised-button color="accent" [disabled]="is_loading" type="button"
                      (click)="backToCampaignGroupSequence()" style="margin: 15px">Cancel
              </button>
            </div>
          </mat-card-actions>

        </mat-card>

      </div>


      <!--    </ng-container>-->


    </form>
  }
</div>
